/** @format */

export const FILTER_STORAGE_KEY = 'coreDataTableFilters'

export const RETAINED_FILTER_STORAGE_KEY = 'retainedTableFilters'

export const RETAINED_FILTER_SCHEMA_VERSION = 1

export const MAX_RESTORED_PAGE = 100000

function clearKeysStartingWith(prefix, storage) {
	for (let i = storage.length - 1; i >= 0; i--) {
		const key = storage.key(i)
		if (key && key.startsWith(prefix)) {
			storage.removeItem(key)
		}
	}
}

export function clearRetainedTableFilters(storage = sessionStorage) {
	clearKeysStartingWith(`${RETAINED_FILTER_STORAGE_KEY}__`, storage)
}

export function clearLegacyTableFilters(storage = sessionStorage) {
	clearKeysStartingWith(`${FILTER_STORAGE_KEY}__`, storage)
}

const SESSION_ENDED_STAMP = { userId: null, ownerId: null, userType: 'session-ended' }

// For when the session the saved filters belong to has ended: a 401/419, or a new login. The retained blobs are
// re-stamped rather than removed, because after an F5 on an expired session the login lands on the reloaded URL with
// its table params, and only a blob of another identity makes the gate strip them. The legacy blobs have no such gate,
// so they are removed, as on logout.
export function expireTableFilters(storage = sessionStorage) {
	const prefix = `${RETAINED_FILTER_STORAGE_KEY}__`
	const keys = []
	for (let i = 0; i < storage.length; i++) {
		const key = storage.key(i)
		if (key && key.startsWith(prefix)) {
			keys.push(key)
		}
	}

	keys.forEach((key) => {
		let blob = null
		try {
			blob = JSON.parse(storage.getItem(key))
		} catch {
			blob = null
		}

		if (blob !== null && typeof blob === 'object' && !Array.isArray(blob)) {
			storage.setItem(key, JSON.stringify({ ...blob, identity: SESSION_ENDED_STAMP }))
		} else {
			storage.removeItem(key)
		}
	})

	clearLegacyTableFilters(storage)
}

export function makeIdentityStamp({ userId, ownerId, userType }) {
	return { userId, ownerId, userType }
}

export function isSameIdentity(stamp, { userId, ownerId, userType }) {
	if (!stamp || typeof stamp !== 'object') {
		return false
	}
	return stamp.userId === userId && stamp.ownerId === ownerId && stamp.userType === userType
}

export function isIsoDateOrNull(x) {
	if (x === null) {
		return true
	}

	// Must be a string matching yyyy-MM-dd pattern
	if (typeof x !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(x)) {
		return false
	}

	const [year, month, day] = x.split('-').map(Number)

	const date = new Date(Date.UTC(year, month - 1, day))

	return (
		date.getUTCFullYear() === year &&
		date.getUTCMonth() === month - 1 &&
		date.getUTCDate() === day
	)
}
